import type { CommsPreference } from "@/lib/api/comms";

/** The categories a shared destination may get (`targetable` absent = yes), at
 *  `scope` when given — the doorbell never goes to a site destination. */
export function targetableCategories(prefs: CommsPreference[], scope?: string): CommsPreference[] {
  return prefs.filter(
    (p) => p.targetable !== false && (!scope || !p.target_scopes || p.target_scopes.includes(scope)),
  );
}

export function targetCategoryOptions(
  prefs: CommsPreference[],
  scope?: string,
): { value: string; label: string }[] {
  return targetableCategories(prefs, scope).map((p) => ({ value: p.category, label: p.label }));
}

/** A new destination starts with every category it can take. */
export function defaultTargetCategories(prefs: CommsPreference[], scope?: string): string[] {
  return targetableCategories(prefs, scope).map((p) => p.category);
}
